export const getHeight = (dimensions) => (100 * dimensions.height) / dimensions.width;
export const toPercentage = (value, width) => (100 * value) / width;
export const fromPercentage = (value, width) => (value * width) / 100;
